import { powerSync, PowerSyncContext } from '@docnboard/sync';
import { type PropsWithChildren, type ReactNode } from 'react';

export const SyncProvider = (props: PropsWithChildren): ReactNode => {
  return (
    <PowerSyncContext.Provider value={powerSync}>
      {props.children}
    </PowerSyncContext.Provider>
  );
};
